export { enUS } from '@/locales/enUS';
export { ptBR } from '@/locales/ptBR';
